import React from "react";
import { CircularProgress } from "@mui/material";

import AppConfirmDialog from "components/Shared/AppConfirmDialog";
import ErrorAlert from "components/Shared/ErrorAlert";

import { useGenerateFonepayPaymentQRMutation } from "store/services/PaymentsApi/paymentApi";

const FonepayQR = React.forwardRef(({ amount = 0, shipmentId }, ref) => {
  const [showConfirm, setShowConfirm] = React.useState(false);
  const [error, setError] = React.useState(null);

  const [generateQr, { data: qrData, isLoading: loadingQR }] =
    useGenerateFonepayPaymentQRMutation();

  const handleGenerateQR = async () => {
    setError(null);
    try {
      setShowConfirm(true);
      await generateQr({ amount, shipmentId }).unwrap();
    } catch (err) {
      setError(err);
    }
  };

  const handleClosQR = () => setShowConfirm(false);

  const renderQR = React.useMemo(() => {
    if (loadingQR) return <CircularProgress size={120} />;
    if (!qrData?.qrMessage) return null;

    return (
      <div className="relative text-center">
        <img
          src={`https://qrcode.nepalcanmove.com/?data=${qrData.qrMessage}`}
          alt="Fonepay QR"
          className="mx-auto aspect-square w-72"
        />
        <div className="mt-5 text-sm">Scan QR to pay Rs. {amount}</div>
      </div>
    );
  }, [amount, loadingQR, qrData?.qrMessage]);

  React.useImperativeHandle(ref, () => ({
    handleGenerateQR,
    handleClosQR,
  }));

  return (
    <AppConfirmDialog
      fullWidth
      hideIcon
      maxWidth="xs"
      title="Pay Via Fonepay"
      open={showConfirm}
      onClose={handleClosQR}
      confirmBtnText="Check Payment"
    >
      <ErrorAlert error={error} />
      <div className="flex flex-col items-center">{renderQR}</div>
    </AppConfirmDialog>
  );
});


export default FonepayQR;
